export default "__VITE_ASSET__BgLPbUcb__"